const cookieNames = {
  locale: 'locale',
  giftData: 'giftData',
  userGender: 'userGender',
  activeFilters: 'activeFilters',
  sameAddresses: 'sameAddresses',
  shippingFields: 'shippingFields',
  facebookGender: 'facebookGender',
  facebookEmailRegistration: 'facebookEmailRegistration',
  pinchmePageEmail: 'pinchmePageEmail',
  referrerLandingPageURL: 'referrerLandingPageURL',
  paymentGiftSubscription: 'paymentGiftSubscription',
  paymentGiftCard: 'paymentGiftCard',
  payPalPaymentGiftSubscription: 'payPalPaymentGiftSubscription',
  payPalGiftCard: 'payPalGiftCard',
  unregisteredUserQuizData: 'unregisteredUserQuizData',
  giftCardCodeForClaiming: 'giftCardCodeForClaiming',
  extraHomeTopButtonClicked: 'extraHomeTopButtonClicked',
  giftCoupon: 'giftCoupon',
  offer: 'offer',
  discountCoupon: 'discountCoupon',
  reactivateSubscription: 'reactivateSubscription',
  makeupIntroFlow: 'makeupIntroFlow',
  skincareIntroFlow: 'skincareIntroFlow',
  firstVisitTimestamp: 'firstVisitTimestamp',
  isPayPalBannerVisible: 'isPayPalBannerVisible',
  isProfileInviteBlockVisible: 'isProfileInviteBlockVisible',
  selectedPlan: 'selectedPlan',
  lastTimeAddToQueue: 'lastTimeAddToQueue',
  priceWithDiscount: 'priceWithDiscount',
  timezone: 'timezone_offset',
  mixPageStories: 'mixPageStories',
  newPaymentCouponCode: 'newPaymentCouponCode',
  logoRedirectUrl: 'logoRedirectUrl',
  paymentCouponFromUser: 'paymentCouponFromUser',
  firstPickProducts: 'firstPickProducts',
  fbPixel: 'fbPixel',
  authCountdown: 'authCountdown',
  mainPageThxNotification: 'mainPageThxNotification',

  // We save here facebook pixel id and use it in GTM.
  // If this cookie is empty we will use default pixel id (is in GTM)
  fbPixelId: 'fbPixelId',

  // We save here flowName. This can help us for ab testing.
  flowName: 'flowName',

  // UTM for dataLayer: will be remove after subscribe
  utmMediumBeforeSubscription: 'utmMediumBeforeSubscription',
  utmSourceBeforeSubscription: 'utmSourceBeforeSubscription',

  // session cookies
  hideCounter: 'hideCounter',
  specialFlowName: 'specialFlowName',
  isImproveSurveyBannerHidden: 'isImproveSurveyBannerHidden',
  isFragranceConceptsBannerHidden: 'isFragranceConceptsBannerHidden',
  isFacebookFlowEnabled: 'isFacebookFlowEnabled',
  collectionsClickPlacement: 'collectionsClickPlacement',
  isPutFirstInQueueModalShown: 'isPutFirstInQueueModalShown',
  buyQueuePageData: 'buyQueuePageData',
  features: 'test_features',
  abTests: 'test_abTests',
  pastPurchaser: 'pastPurchaser',
  banners: {
    recommendationsImprove: 'RecommendationsImproveBanner',
    appStoreBanner: 'appStoreBanner',
  },
  unpauseData: 'unpauseData',
  resubscribeCode: 'resubscribeCode',
  casesSubscription: 'casesSubscription',
  acquisitionQuizData: 'acquisitionQuizData',
  mobileMenuFirstClick: 'mobileMenuFirstClick',
  bindedCoupon: 'bindedCoupon',
  isSocialLogin: 'isSocialLogin',
  isShippingFormValid: 'isShippingFormValid',
  shippingFormInitialValues: 'shippingFormInitialValues',
  showInfoInPickPage: 'showInfoInPickPage',
  isFreeTrialOrgFlow: 'isFreeTrialOrgFlow',
  isFreeTrialCoupon: 'isFreeTrialCoupon',
  showAttentiveModal: 'showAttentiveModal',
  isPrepaidCardWithSubscriptionPlansModalHidden: 'isPrepaidCardWithSubscriptionPlansModalHidden',

  ccpa: 'doNotSellMyPersonalInfo',
  amazonBeginData: 'amazonBeginData', // only for amazon v2 checkout
}


export default cookieNames
